import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"62.4\" height=\"46.4\" x=\".8\" y=\".8\" stroke=\"currentColor\" stroke-width=\"1.6\" rx=\".8\"></rect><circle cx=\"57.101\" cy=\"5.1\" r=\"1.1\" fill=\"#9EA6B3\"></circle><circle cx=\"57.1\" cy=\"9.7\" r=\"1.1\" fill=\"#9EA6B3\"></circle><circle cx=\"57.1\" cy=\"14.3\" r=\"1.1\" fill=\"#9EA6B3\"></circle><rect width=\"52.8\" height=\"17.6\" x=\"5.601\" y=\"24.8\" fill=\"#E0E2E6\" rx=\".8\"></rect><rect width=\"26.4\" height=\"1.6\" x=\"5.601\" y=\"6.4\" fill=\"currentColor\" rx=\".8\"></rect><rect width=\"26.4\" height=\"5.6\" x=\"5.601\" y=\"11.2\" fill=\"#E0E2E6\" rx=\".8\"></rect>", 7)
  ]))]))
}
export default { render: render }